import DesignTokens from '@tableau/design-tokens';
import { TabStyles, TextFieldWidget } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { cssClass } from '~src/style';
import { applyColor }from '~src/style/ColorService';

import { SettingsStyles } from '../../../styles/CommonStyles';


export type EditClusterNameFieldProps = Readonly<{
  clusterName: string;
  onClusterNameChange: (poolName: string) => void;
  hasError: boolean;
  onHasErrorChange: (hasError: boolean) => void;
  existingClusterNames: string[];
  description: string;
}>;

export function EditClusterNameField(props: EditClusterNameFieldProps) {
  const handleClusterNameChange = (value: string) => {
    props.onClusterNameChange(value);
    const hasError = props.existingClusterNames.includes(value);
    props.hasError !== hasError && props.onHasErrorChange(hasError);
  };
  const descriptionDivClassName = `${SettingsStyles.settingsGroupDescription}`;

  return (
    <div className={fieldClass}>
      <div className={descriptionDivClassName}
                data-tb-test-id={'pool-name-text-details'}>
          {props.description}
      </div>
      <TextFieldWidget
        label={Messages.dataConnectSiteSettingsClusterColumnName()}
        value={props.clusterName}
        onChange={e => handleClusterNameChange(e.target.value)}
        onClear={() => handleClusterNameChange('')}
        maxLength={80}
        placeholder={Messages.dataConnectSiteSettingsClusterNamePlaceholder()}
        testId={'pool-name-text-field'}
        style={{ width: '100%' }}
        className={textFieldClass}
      />
      {props.hasError &&
        <div className={errorClass}>
          {Messages.dataConnectSiteSettingsEditClusterNameError()}
        </div>
      }
    </div>
  );
}

const fieldClass = style({ marginBottom: TabStyles.Sizing.BaseUnit * 5 });

const textFieldClass = cssClass('edit-pool-dialog', 'field', {
  width: '100%'
});

export const errorClass = style({ marginTop: TabStyles.Spacing.DefaultSpace, color: applyColor(DesignTokens.color.font.default.error, TabStyles.Colors.AttentionDark) });
